import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { AdminProvider } from './context/AdminContextDetail'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'sweetalert2/src/sweetalert2.scss'
import './assets/styles/styles.scss'

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 0
        }
    }
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <QueryClientProvider client={queryClient}>
        <AdminProvider>
            <App />
        </AdminProvider>
        <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
